var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.loading } },
    [
      _c(
        "vxe-grid",
        _vm._b(
          {
            ref: "xGrid",
            staticClass: "column-sortable-grid",
            attrs: { "column-key": "", "auto-resize": true },
            on: { "cell-dblclick": _vm.cellDbClick },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [_vm._t("operate", null, { row: row })]
                  },
                },
                {
                  key: "toolbar_buttons",
                  fn: function () {
                    return [
                      _vm.toolbarConfig && _vm.toolbarConfig.templatelSlots
                        ? _vm._t(
                            _vm.toolbarConfig &&
                              _vm.toolbarConfig.templatelSlots
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              true
            ),
          },
          "vxe-grid",
          _vm.gridOptions,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }